import React, {Component} from 'react';
import './SignUpPageComponent.less';
import TandCComponent from '../TandCComponent/TandCComponent';
import HeaderSectionComponent from '../HeaderSectionComponent/HeaderSectionComponent';
import CalloutCardComponent from '../CalloutCardComponent/CalloutCardComponent';
import SignUpComponent from '../SignUpComponent/SignUpComponent';

class SignUpPageComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailAddress: this.props.emailAddress,
            currentPage: this.props.currentPage,
            error: '',
            errorTitle: ''
        };
        this.handleError = this.handleError.bind(this);
    }

    handleError(error) {
        this.setState({error});
    }

    render() {
        let cardContent = (<SignUpComponent
            actionLocation={this.props.actionLocation}
            lingua={this.props.lingua}
            emailAddress= {this.props.emailAddress}
            service={this.props.service}
            handleError={this.handleError}
            site={this.props.site}
            updatePage={this.props.updatePage}
            setFirstName={this.props.setFirstName}
            setEmail={this.props.setEmail}
            passwordType = {this.props.passwordType}
            showHidePassword={this.props.showHidePassword}
            isWaiting={this.props.isWaiting}
            enableLoading={this.props.enableLoading}
            disableLoading={this.props.disableLoading}
            setAuthJson={this.props.setAuthJson}
            useNewEndpoints={this.props.useNewEndpoints}
            multiUserEnabled={this.props.multiUserEnabled}
                           />);
        return (
            <div className="border-border-color">
                <HeaderSectionComponent header={this.props.lingua.read('lex.header.signup')}/>
                <CalloutCardComponent content={cardContent} error={this.state.error} errorTitle={this.state.errorTitle}/>
                <TandCComponent lingua={this.props.lingua} multiUserEnabled={this.props.multiUserEnabled}/>
            </div>
        );
    }
}

export default SignUpPageComponent;
